import createIcon from '../../createIcon';

/**
 * @component @name Autorenew
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNlY5TDE2IDVMMTIgMVY0QzcuNTggNCA0IDcuNTggNCAxMkM0IDEzLjU3IDQuNDYgMTUuMDMgNS4yNCAxNi4yNkw2LjcgMTQuOEM2LjI1IDEzLjk3IDYgMTMuMDEgNiAxMkM2IDguNjkgOC42OSA2IDEyIDZaTTE4Ljc2IDcuNzRMMTcuMyA5LjJDMTcuNzQgMTAuMDQgMTggMTAuOTkgMTggMTJDMTggMTUuMzEgMTUuMzEgMTggMTIgMThWMTVMOCAxOUwxMiAyM1YyMEMxNi40MiAyMCAyMCAxNi40MiAyMCAxMkMyMCAxMC40MyAxOS41NCA4Ljk3IDE4Ljc2IDcuNzRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Autorenew = createIcon('Autorenew', [
  [
    'path',
    {
      d: 'M12 6V9L16 5L12 1V4C7.58 4 4 7.58 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13.01 6 12C6 8.69 8.69 6 12 6ZM18.76 7.74L17.3 9.2C17.74 10.04 18 10.99 18 12C18 15.31 15.31 18 12 18V15L8 19L12 23V20C16.42 20 20 16.42 20 12C20 10.43 19.54 8.97 18.76 7.74Z',
      key: '11gw2r',
    },
  ],
]);

export default Autorenew;
